// extracted by mini-css-extract-plugin
module.exports = {"total":"oweMoney_total__BCqPY","fixed":"oweMoney_fixed__1FEUU"};